var SubscriptionOptions = class extends HTMLElement {
  constructor() {
    super();
		this.subscription_options = this.querySelectorAll('.option-wrapper > label');
		this.subscription_option_wrappers = this.querySelectorAll('.option-wrapper');
		this.subscription_menu_opener = this.querySelector('.current-subscription-option');
		this.subscriptionLabelHeight = this.querySelector('.option-wrapper > label').offsetHeight;

		this.subscription_cart_wrapper_toggler = this.closest('.cart-item')?.querySelector('.toggle-subscription');
  }


  connectedCallback() {
     this.subscription_options.forEach(option => {
       option?.addEventListener('click', this.selectOption.bind(this));
     });
		 this.subscription_option_wrappers.forEach(wrapper => {
				wrapper.style.height = this.subscriptionLabelHeight + "px";
		 });
		 this.subscription_menu_opener?.addEventListener('click', this.openCloseSubscriptionMenu.bind(this));

		 this.subscription_cart_wrapper_toggler?.addEventListener('click', this.openCloseCartSubscriptionWrapper.bind(this));
  }

  disconnectedCallback() {
		this.subscription_options.forEach(option => {
			option?.removeEventListener('click', this.selectOption);
		});
		this.subscription_menu_opener?.removeEventListener('click', this.openCloseSubscriptionMenu);

		this.subscription_cart_wrapper_toggler?.removeEventListener('click', this.openCloseCartSubscriptionWrapper.bind(this));
  }

	selectOption(event){
		event.preventDefault();
		const option = event.currentTarget;
		this.uncheckRadioButton();
		let selectedRadioButton = option.querySelector('input[type=radio]');
		let selectedOptionWrapper = option.closest('.option-wrapper')
		if(!selectedOptionWrapper.classList.contains('option-selected')) {
			selectedOptionWrapper.classList.add('option-selected');
		}
		if(selectedOptionWrapper.classList.contains('with-sub')) {
			this.updateContainerHeight(selectedOptionWrapper,'close');
            this.querySelector('.subscription-options-wrapper').classList.remove('options-opened');
		}
		else {
			this.updateContainerHeight(this.querySelector('.option-wrapper.with-sub'));
		}
		selectedRadioButton.checked = true;
	}

	uncheckRadioButton() {
		let checkedRadioButton = this.querySelectorAll('input[type=radio]');
		let radioButtonWrapper;
		checkedRadioButton.forEach(radioButton => {
			radioButton.checked = false;
			if (radioButton) {
				radioButtonWrapper = radioButton.closest('.option-wrapper');
				if(radioButtonWrapper.classList.contains('option-selected')) {
					radioButtonWrapper.classList.remove('option-selected');
				}
			}
		});
	}

	openCloseSubscriptionMenu(event) {
		event.preventDefault();
		const subscriptionMenuOpener = event.currentTarget;
		const subscriptionOptionsWrapper = subscriptionMenuOpener.closest('.subscription-options-wrapper');
		const subscribeOptionWrapper = subscriptionMenuOpener.closest('.option-wrapper');
		let containerHeight = 0;
		if(subscriptionOptionsWrapper.classList.contains('options-opened')) {
			this.subscriptionMenuOpenerHeight = this.querySelector('.subscription-options-wrapper').offsetHeight;
			containerHeight = this.subscriptionLabelHeight + this.subscriptionMenuOpenerHeight;
			this.updateContainerHeight(subscribeOptionWrapper,'close');
			subscriptionOptionsWrapper.classList.remove('options-opened');
		}
		else {
			subscriptionOptionsWrapper.classList.add('options-opened');

			containerHeight = this.subscriptionLabelHeight + this.subscriptionMenuOpenerHeight + this.subscriptionPlansMenuHeight;
			this.updateContainerHeight(subscribeOptionWrapper,'open');
		}

	}

	updateContainerHeight(container,animationType) {
		let newHeight = 0;
		let subscriptionMenuOpenerHeight = 0;
		let subscriptionPlansMenuHeight = 0;
		switch(animationType) {
			case 'close':
			 	subscriptionMenuOpenerHeight = this.querySelector('.current-subscription-option').offsetHeight;
				newHeight = this.subscriptionLabelHeight + subscriptionMenuOpenerHeight;
				break;

			case 'open':
				subscriptionMenuOpenerHeight = this.querySelector('.current-subscription-option').offsetHeight;
				subscriptionPlansMenuHeight = this.querySelector('.subscription-plan-options-wrapper').offsetHeight;
				newHeight = this.subscriptionLabelHeight + subscriptionMenuOpenerHeight + subscriptionPlansMenuHeight;
				break;

			default:
				newHeight = this.subscriptionLabelHeight;
				break;
		}
		newHeight = newHeight + 'px';
		container.style.height = newHeight;
	}

	openCloseCartSubscriptionWrapper(event) {
		if(event.target.classList.contains('active')){
			event.target.classList.remove('active');
			this.closest('.cart-item__subscription-options').classList.add('hidden');
		} else {
			event.target.classList.add('active')
			this.closest('.cart-item__subscription-options').classList.remove('hidden');
		}

	}
}
if (!window.customElements.get("subscription-options")) {
  window.customElements.define("subscription-options", SubscriptionOptions);
}

var TooltipOpener = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.removeItemButtons.forEach(button => {
    //   button?.addEventListener('click', this.removeProduct.bind(this));
    // });
  }

  disconnectedCallback() {
    // this.removeItemButtons.forEach(button => {
    //   button?.removeEventListener('click', this.removeProduct);
    // });
  }
}
if (!window.customElements.get("tooltip-opener")) {
  window.customElements.define("tooltip-opener", TooltipOpener);
}
